<template>
    <q-page padding>
        <div class="row q-mb-sm">
            <div class="col-xs-12 col-sm-12">
                <div class="q-display-1 text-secondary">
                    <q-icon name="fas fa-list" class="q-mb-sm" /> {{ $t(title_trainings) }}
                </div>
            </div>
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="modules" :label="$t('modules')" v-show="showTab" />
            <q-tab slot="title" v-if="hasGames" name="games" :label="$t('games')" v-show="showTab" />
            <q-tab slot="title" name="tests" :label="$t('tests')" v-show="showTab" />
            <q-tab slot="title" name="reaction_tests" :label="$t('reaction_tests')" v-show="showTab" v-if="selected_client_params.group_training_use_evaluations" />
            <q-tab slot="title" name="support_material" :label="$t('support_materials')" v-show="showTab" />
            <q-tab slot="title" name="configure_and_publish" :label="$t('configure_and_publish')" v-show="showTab" />
            <q-tab slot="title" v-if="useCommentsGroupTraining" name="comments" :label="$t('comments')" v-show="showTab" />
            <q-tab slot="title" v-if="hasForum" name="discussions" :label="$t('discussions')" v-show="showTab" />

            <q-tab-pane name="basic-data">
                <basic-data :managerTrainings="permissions.trainings_manage" :set_score="permissions.trainings_set_score" />
            </q-tab-pane>

            <q-tab-pane name="modules">
                <modules :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="games">
                <games :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="tests">
                <tests :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="reaction_tests">
                <reaction-tests :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="support_material">
                <support-material :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="configure_and_publish">
                <configure-and-publish @duplicate="changeTab" :managerTrainings="permissions.trainings_manage"/>
            </q-tab-pane>

            <q-tab-pane name="comments">
                <comments origin="training" />
            </q-tab-pane>

            <q-tab-pane name="discussions">
                <discussions />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicDataTab from 'components/admin/training/BasicDataTab'
import ModulesTab from 'components/admin/training/ModulesTab'
import GamesTab from 'components/admin/training/GamesTab'
import TestsTab from 'components/admin/training/TestsTab'
import ReactionTestsTab from 'components/admin/training/ReactionTestsTab'
import SupportMaterialTab from 'components/admin/training/SupportMaterialTab'
import ConfigureAndPublishTab from 'components/admin/training/ConfigureAndPublishTab'
import Comments from 'components/admin/Comments'
import Discussions from 'components/admin/training/Discussions'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'training', 'admin', 'discussions', 'games'] },

    data() {
        return {
            id_training: '',
            tab: 'basic-data',
            selected_client_params: [],
            permissions: {
                trainings_manage: false,
                trainings_set_score: false
            }
        }
    },

    components: {
        'basic-data': BasicDataTab,
        'modules': ModulesTab,
        'games': GamesTab,
        'tests': TestsTab,
        'reaction-tests': ReactionTestsTab,
        'support-material': SupportMaterialTab,
        'configure-and-publish': ConfigureAndPublishTab,
        'comments': Comments,
        'discussions': Discussions
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_client_module_items: 'common/user_client_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showTab() {
            if (this.id_training != 0) return true
            else return false
        },

        title_trainings(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_trainings == "" ? 'trainings' : obj.title_trainings
				}
			}
        },

        useCommentsGroupTraining() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) return  obj.use_comments_group_training
            else return true
        },

        hasGames() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    return obj.has_games
                }
            }
            else return false
        },

        hasForum() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    return obj.has_forum
                }
            }
            return false
        }
    },

    methods: {
        changeTab() {
            this.tab = 'basic-data'
        },

        checkPermissions() {
            const client = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (client) {
                for (const [key, value] of Object.entries(this.permissions)) {
                    let obj = client.module_items.find(obj => obj.slug === key)
                    if (obj) {
                        this.permissions[key] = obj.permission
                    }
                }
            } else return
        },
    },

    watch: {
        '$route': function (refreshPage) {
            this.id_training = this.$route.params.id
        }
    },

    created() {
        this.id_training = this.$route.params.id
        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
        this.checkPermissions()
    }
}
</script>

<style>

</style>
